import { GridElement } from '..'
import IframeResizer from 'iframe-resizer-react'
import { navigationService } from '../../services'

export const UmbracoForm: React.FC<GridElement> = props => {
    const onMessageReceived = (ev: { iframe: IframeResizer.IFrameComponent; message: any }) => {
        if (ev.message && ev.message['path']) {
            console.debug('Received message to go to path: ' + ev.message['path'])
            navigationService.goTo(ev.message['path'])
        }
    }

    return (
        <div
            style={{
                marginTop: '32px',
            }}
        >
            <IframeResizer
                log
                src={'/?altTemplate=root&formId=' + props.value['FormGuid'] + '&theme=' + props.value['FormTheme']}
                style={{ width: '1px', minWidth: '100%', border: 'none' }}
                onMessage={onMessageReceived}
            />
        </div>
    )
}
